import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Home, Search } from "lucide-react";
import { useSEO } from "@/hooks/useSEO";

const NotFound = () => {
  const location = useLocation();

  useSEO({
    title: "Página no encontrada (404) | Patinete Eléctrico Segunda Mano",
    description: "La página que buscas no existe. Vuelve al inicio o explora nuestro marketplace de patinetes eléctricos.",
    noindex: true,
  });

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <main className="flex min-h-screen items-center justify-center bg-gradient-to-b from-background via-muted/30 to-background px-4">
      <div className="text-center max-w-md">
        <p className="font-display text-7xl font-extrabold bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
          404
        </p>
        <h1 className="mt-4 font-display text-2xl font-bold md:text-3xl">
          Página no encontrada
        </h1>
        <p className="mt-3 text-muted-foreground">
          La página que buscas no existe o ha sido movida. Vuelve al inicio o explora nuestros patinetes.
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Button asChild size="lg" className="gap-2">
            <Link to="/"><Home className="h-4 w-4" /> Volver al inicio</Link>
          </Button>
          <Button asChild size="lg" variant="outline" className="gap-2">
            <Link to="/buscar"><Search className="h-4 w-4" /> Buscar patinetes</Link>
          </Button>
        </div>
      </div>
    </main>
  );
};

export default NotFound;
